import { getParentSize, subscribeOnMessengerParentResizeMessages } from '@widgets/messenger/utils/parentResizeMessages'
import { onMounted, ref } from '@/composition/vue/compositionApi'

export const useWidgetParentSize = (messengerId: string) => {
  const isParentSmaller = ref(false)
  const isParentMobile = ref(false)

  subscribeOnMessengerParentResizeMessages(messengerId, ({ isParentSmaller: isSmaller, isMobile }) => {
    isParentSmaller.value = isSmaller
    isParentMobile.value = isMobile
  })

  onMounted(async () => {
    const parentResizeData = await getParentSize(messengerId)

    isParentSmaller.value = !!parentResizeData?.isParentSmaller
    isParentMobile.value = !!parentResizeData?.isMobile
  })

  return {
    isParentSmaller,
    isParentMobile,
  }
}
